/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

export const UHF_EVENT = 'trackEventNoEcommerce';

const buildUHFParams = (
  eventCategory: string,
  eventLabel: string,
  screenName: string,
  eventAction: string = 'click',
) => ({
  event: UHF_EVENT,
  eventCategory,
  eventAction,
  eventLabel,
  screenName,
});

export const buildUHFHeaderLogoParams = (
  label: string,
  lob: string | null,
  screenName: string,
) => buildUHFParams(`${lob ?? 'null'}|uhf`, `header|logo|${label}`, screenName);

export const buildUHFHeaderNavParams = (
  label: string,
  lob: string | null,
  screenName: string,
) =>
  buildUHFParams(
    `${lob ?? 'null'}|uhf`,
    `header|navigation|${label}`,
    screenName,
  );

export const buildUHFHeaderAvatarParams = (
  label: string,
  lob: string | null,
  screenName: string,
) =>
  buildUHFParams(`${lob ?? 'null'}|uhf`, `header|avatar|${label}`, screenName);

export const buildUHFHeaderMenuParams = (
  label: string,
  lob: string | null,
  screenName: string,
) => buildUHFParams(`${lob ?? 'null'}|uhf`, `header|menu|${label}`, screenName);

export const buildUHFHeaderLocaleCurrencyParams = (
  label: string,
  lob: string | null,
  screenName: string,
) =>
  buildUHFParams(
    `${lob ?? 'null'}|uhf`,
    `header|locale_currency|${label}`,
    screenName,
  );

export const buildUHFHeaderDarkModeParams = (
  label: string,
  lob: string | null,
  screenName: string,
) =>
  buildUHFParams(
    `${lob ?? 'null'}|uhf`,
    `header|dark_mode|${label}`,
    screenName,
  );

export const buildUHFFooterParams = (
  sectionTitle: string,
  linkText: string,
  lob: string | null,
  screenName: string,
) =>
  buildUHFParams(
    `${lob ?? 'null'}|uhf`,
    `footer|${sectionTitle}|${linkText}`,
    screenName,
  );

export const buildUHFLoginTooltipParams = (
  label: string,
  lob: string | null,
  screenName: string,
  locale: string,
  eventAction?: string,
) =>
  buildUHFParams(
    `${lob ?? 'null'}|uhf`,
    `${label}|${locale}`,
    screenName,
    eventAction,
  );
